import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';
import { Inject, Injectable, Optional } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MomentTimeZoneEnum } from '../enums/moment-timezone.enum';

/**
 * This world specifically exists to allow Angular's MatDatepicker to provide dates based on the application's decided timezone
 * * Environment files contain the "siteTimeZone"
 * * Angular.json contains the configuration on which environment file is used
 */
@Injectable()
export class CustomMomentDateAdapter extends MomentDateAdapter {
    
    // Set the desired timezone here (e.g., 'America/New_York' or 'UTC')
    private readonly desiredTimezone: string = MomentTimeZoneEnum[environment.configs.siteTimeZone];

    constructor(
        @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
        @Optional() @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS) options?: { useUtc: boolean }
    ) {
        super(dateLocale, options);
    }

    override clone(date: moment.Moment): moment.Moment {
        // This ensures the timezone 'desiredTimezone' is carried over 
        // to every internal copy Material makes.
        const returnDate = date.clone().tz(this.desiredTimezone);
        return returnDate;
    }

    // Override - ON INPUT - this ensures the date entered is based on the timezone configured, not the browser local time
    override parse(value: any, parseFormat: string | string[]): moment.Moment | null {
        if (value && typeof value === 'string') {
            // Parse the string directly into the target timezone
            const m = moment.tz(value, parseFormat, this.desiredTimezone);
            return m.isValid() ? m : null;
        }
        return value ? moment.tz(value, this.desiredTimezone) : null;
    }

    override today(): moment.Moment {
        return moment.tz(this.desiredTimezone).startOf('day');
    }

    // Override the createDate method to use moment-timezone
    override createDate(year: number, month: number, date: number): moment.Moment {
        // Create the date in the specified timezone
        return moment.tz({ year, month, date, hour: 0, minute: 0, second: 0, millisecond: 0 }, this.desiredTimezone);
    }

    // Override deserialize to handle incoming dates correctly
    override deserialize(value: any): moment.Moment | null {
        if (value == null) {
            return null;
        }

        let date: moment.Moment;
        // let szDate = moment.utc("1900-01-01").tz(this.desiredTimezone);
        // let date2 = moment(new Date("1900-01-01")).tz(this.desiredTimezone);
        // console.log(`szDate:${szDate}`);
        // console.log(`date2:${date2}`);
        if (typeof value === 'string') {
            // Parse the incoming string as UTC and then convert to the desired timezone
            date = moment.utc(value).tz(this.desiredTimezone);
        } else {
            // For a Date object, treat it as local and convert to desired timezone
            date = moment(value).tz(this.desiredTimezone);
        }
        // Ensure the date is valid
        return date.isValid() ? date : null;
    }

    // Ensure formatting uses the timezone context
    // override format(date: moment.Moment, displayFormat: string): string {
    //     return date.clone().tz(this.desiredTimezone).format(displayFormat);
    // }
    // You might also need to override parse and today depending on specific requirements
    // ...
}